import React from "react";

const Input = ({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  name,
  required = false,
  error,
  className,
  onKeyDown,
  ...rest
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="text-gray-700 mb-2 font-regular flex items-center text-sm"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        onKeyDown={(e) => onKeyDown && onKeyDown(e)}
        placeholder={placeholder}
        // required={required}
        className={`font-regular text-sm px-4 py-2 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary ${
          error ? "border-red-500" : "border-gray-300"
        }`}
        {...rest} // Spread other props like minLength, maxLength, etc.
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default Input;
